import { render, staticRenderFns } from "./AditionalsForm.vue?vue&type=template&id=18132a32&scoped=true"
import script from "./AditionalsForm.vue?vue&type=script&lang=js"
export * from "./AditionalsForm.vue?vue&type=script&lang=js"
import style0 from "./AditionalsForm.vue?vue&type=style&index=0&id=18132a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18132a32",
  null
  
)

export default component.exports